import Transfer from './transfer';

export default Transfer;
